import unicodeStringCompare from './unicodeStringCompare';

const numRegex = /^[0-9]+$/;

export function sortFunc(a, b) {
    if (numRegex.test(a.grade) && numRegex.test(b.grade)) {
        let cmp = parseInt(a.grade, 10) - parseInt(b.grade, 10);

        if (cmp) {
            return cmp;
        }
    }

    return unicodeStringCompare(a.fullName || a.name, b.fullName || b.name);
}

export default function sortParticipants(participants) {
    return participants.sort(sortFunc);
}



// WEBPACK FOOTER //
// ./src/utils/sortParticipants.js